import axios from 'axios';

class UserWebservice {
    /**
     * Call the login method on api
     *
     * @param username Email address
     * @param password Password
     */
    public login(email: string, password: string) {
        return axios.post('/auth/login', {
            grant_type: 'password',
            email,
            password,
        });
    }

    public getUserInfo() {
        return axios.get('/userinfo');
    }
}

export const userWebservice = new UserWebservice();
